import React from "react";
import { 
    Container,
    Button
 } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DatatableTables from "./DatatableTables";

const Users = () => {

    //meta title
    document.title="Users | Form";

  return (
    <React.Fragment>
      {/* <div className="page-content"> */}
        {/* <Container fluid> */}
          {/* Render Breadcrumbs */}
          {/* <Breadcrumbs title="Setting" breadcrumbItem="Users" /> */}
          <DatatableTables />

        {/* </Container> */}
      {/* </div> */}
    </React.Fragment>
  )
}

export default Users;
